import clsx from "clsx";
import { IFactoringCompany } from "models/HaulPay";

type FactoringCompanyProps = {
  factoring_company: IFactoringCompany;
  onClickCompany: VoidFunction;
};

export default function FactoringCompany({
  factoring_company,
  onClickCompany
}: Readonly<FactoringCompanyProps>) {
  const fullAddress = [
    factoring_company.street_one,
    factoring_company.city,
    factoring_company.state
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <button
      type="button"
      className="grid w-full gap-1 px-4 py-3 text-left transition-colors rounded-lg hover:bg-background desktop:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_auto] desktop:items-center desktop:gap-4"
      onClick={onClickCompany}>
      <span className="flex min-w-0 flex-col">
        <span className="font-semibold break-words">{factoring_company.name}</span>
        {fullAddress ? <span className="text-sm text-placeholder">{fullAddress}</span> : null}
      </span>
      <span className="min-w-0 text-sm break-all text-placeholder">{factoring_company.email}</span>
      <span
        className={clsx(
          "w-fit rounded-full px-2.5 py-1 text-xs font-semibold uppercase",
          factoring_company.status === "approved"
            ? "bg-success/10 text-success"
            : "bg-primary/10 text-primary"
        )}>
        {factoring_company.status}
      </span>
    </button>
  );
}
